<app-info-card
  [columns]="2"
  [solution]="solution"
  title="{{ zxProject.name }}"
  description="{{ zxProject.description }}"
  [headerRouterLink]="this.routerLink"
  [infoMap]="this.infoMaps"
  [collapsedItems]="2"
>
</app-info-card>
